import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { AuthService } from '../../../core/services/auth/auth.service'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { SearchQuoteRefusalReasonModel } from '../../../core/models/quote-refusal-reason.model'
import { QuoteRefusalReasonService } from '../../../core/services/purchases/quote-refusal-reason/quote-refusal-reason.service'
import { QuoteRefusalReasonCreateComponent } from '../../../features/purchases/quote-refusal-reason-create/quote-refusal-reason-create.component'
import { QuoteRefusalReasonEditComponent } from '../../../features/purchases/quote-refusal-reason-edit/quote-refusal-reason-edit.component'
import { ModalToggleStatusQuoteRefusalReasonComponent } from '../../../features/purchases/modal-toggle-status-quote-refusal-reason/modal-toggle-status-quote-refusal-reason.component'

@Component({
  selector: 'quote-refusal-reason',
  imports: [
    MatCard,
    MatProgressBar,
    TableListComponent,
    FormSearchComponent,
    MatPaginatorModule,
    QuoteRefusalReasonCreateComponent,
  ],
  templateUrl: './quote-refusal-reason.component.html',
  styleUrl: './quote-refusal-reason.component.scss',
  providers: [AuthService],
  standalone: true,
})
export class QuoteRefusalReasonComponent implements OnInit {
  constructor(
    private quoteRefusalReasonService: QuoteRefusalReasonService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchQuoteRefusalReasonModel =
    new SearchQuoteRefusalReasonModel()
  inputSearch = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'active',
      key: 'ativo',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, active: false },
      description: 'Ações',
    },
  ]
  screen = 'motivo recusa cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: true,
        delete: false,
        active: true,
      }
    }
  }

  // Tela liberada para todos os perfis enquanto não há cadastro de permissão para ela
  checkPermission(permission: string) {
    return true
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchQuoteRefusalReasonModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    // lista vazia volta como 206 com data null
    if (response.data) {
      for (const item of response.data) {
        list.push({ ...item, ativo: item.ativo == 'S' ? 'S' : 'N' })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens ?? 0
  }

  getListItems() {
    this.loading = true
    this.quoteRefusalReasonService
      .listPagedQuoteRefusalReason(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: () => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.quoteRefusalReasonService
      .searchPagedQuoteRefusalReason(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: () => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(QuoteRefusalReasonEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '700px',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  statusItem(item: any) {
    const dialogRef = this.dialog.open(
      ModalToggleStatusQuoteRefusalReasonComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '900px',
        width: '900px',
        data: { item: item },
      },
    )
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
